import React from 'react';
import InputMask from 'react-input-mask';

const PhoneMaskInput = (props: any) => {
  return (
    <InputMask
      dir="ltr"
      textAlign="left"
      {...props}
      mask="+212 999 999 999"
      maskChar=""
    />
  );
};

export default PhoneMaskInput;
